<template>
  <div class="advanced-config-container">
    <div class="main-content">
      <div class="left-panel" style="">
        <!-- 左上：分组信息 -->
        <div class="section-card section-card-group">
          <div class="section-title">{{ $str.getKey('策略控制/分组信息') }}</div>
          <div class="group-block-container">
            <div v-for="(group, groupIndex) in groupedElinkList" :key="groupIndex" class="group-block">
              <div class="card-header">
                <span class="card-index">{{ group.groupIndex }}</span>
              </div>

              <div class="card-body">
                <div class="elink-details">
                  <div class="elink-list-section">
                    <template v-if="group.eLinkSettingList.length > 0">
                      <el-card v-for="(elink, elinkIndex) in group.eLinkSettingList" :key="elinkIndex"
                        class="elink-list-section-card">
                        <div class="detail-item">
                          <span class="item-label">{{ $str.getKey('策略控制/eLink标识') }}</span>
                          <span class="item-value">{{ elink.uuid }}</span>
                        </div>
                        <div class="detail-item">
                          <span class="item-label">{{ $str.getKey('策略控制/需量(kW)') }}</span>
                          <span class="item-value">{{ elink.demandMax || 0 }}</span>
                        </div>
                        <!-- <div class="detail-item">
                          <span class="item-label">{{ $str.getKey('策略控制/防逆流') }}</span>
                          <span class="item-value">{{ elink.demandMin > -6000 ? $str.getKey('策略控制/开启') :
                            $str.getKey('策略控制/关闭') }}</span>
                        </div> -->
                      </el-card>
                    </template>
                    <el-empty v-else :description="$str.getKey('策略控制/暂无设备')"></el-empty>
                  </div>
                </div>

                <!-- 下部：分组级别设置（可编辑） -->
                <div class="group-settings-section">
                  <div class="setting-item vertical-item">
                    <div class="setting-label">{{ $str.getKey('策略控制/无功工作模式') }}</div>
                    <div class="setting-control">
                      <el-select v-if="group.eLinkSettingList.length > 0"
                        v-model="group.eLinkSettingList[0].reactiveMode" :placeholder="$str.getKey('策略控制/请选择无功工作模式')"
                        @change="onReactiveModeChange(group.eLinkSettingList)">
                        <el-option :value="1" :label="$str.getKey('策略控制/不出无功')"></el-option>
                        <el-option :value="2" :label="$str.getKey('策略控制/优先出无功')"></el-option>
                        <el-option :value="3" :label="$str.getKey('策略控制/优先出有功')"></el-option>
                      </el-select>
                      <el-select v-else disabled :placeholder="$str.getKey('策略控制/请选择无功工作模式')">
                        <el-option :value="1" :label="$str.getKey('策略控制/不出无功')"></el-option>
                        <el-option :value="2" :label="$str.getKey('策略控制/优先出无功')"></el-option>
                        <el-option :value="3" :label="$str.getKey('策略控制/优先出有功')"></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-empty class="empty-card" v-if="groupedElinkList.length === 0" :image="noDataIcon"
              :description="$str.getKey('策略控制/暂无数据')"></el-empty>
          </div>


        </div>

        <!-- 左中：参数设置模块 -->
        <div class="section-card">
          <div class="section-title">{{ $str.getKey('策略控制/参数设置') }}</div>
          <div class="section-content">
            <div class="param-form-container">
              <el-form label-position="left" label-width="120px" :model="paramForm" ref="paramFormRef"
                class="param-form">
                <el-form-item :label="$str.getKey('策略控制/箱变容量变比')" prop="transformerRatio">
                  <template #label>
                    <span>
                      {{ $str.getKey('策略控制/箱变容量变比') }}
                    </span>
                  </template>
                  <div class="form-input-row">
                    <el-select v-model="selectedRatioElinks" multiple collapse-tags collapse-tags-tooltip
                      :placeholder="$str.getKey('策略控制/请选择eLink')" class="elink-select">
                      <el-option v-for="item in elinkOptions" :key="item.uuid" :label="item.label"
                        :value="item.uuid" />
                    </el-select>
                    <el-input-number v-model="paramForm.transformerRatio" :min="0" :max="1" :step="0.01" :precision="2"
                      :placeholder="$str.getKey('策略控制/请输入0~1之间的值')" class="transformer-ratio-input" />
                    <el-button type="primary" @click="saveParamSettings" class="save-btn">{{ $str.getKey('策略控制/保存参数设置')
                      }}</el-button>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <!-- 自动需量模块 -->
        <div class="section-card" v-if="(autoDemand == 0 || autoDemand == 1) && groupedElinkList.length > 0">
          <div class="section-title">{{ $str.getKey('策略控制/自动需量') }}</div>
          <!--  -->
          <div class="auto-demand-switch">
            <span class="switch-label">{{ $str.getKey('策略控制/自动需量') }}</span>
            <el-switch v-model="isAutoDemandOpen" @change="toggleAutoDemand" />
          </div>
          <div class="section-content" v-if="isAutoDemandOpen">
            <!-- 根据分组动态生成模块 -->
            <div class="demand-modules-container">
              <div>
                <div class="demand-module" v-for="(group, groupIndex) in groupedElinkList" :key="groupIndex">
                  <!-- 左侧：分组信息 -->
                  <div class="demand-group-info">
                    <div class="group-title">{{ $str.getKey('策略控制/组') }}{{ group.groupIndex }}</div>
                    <div class="device-item-info-item">
                      <span class="device-item-info-item-label">{{ $str.getKey('策略控制/整组需量(kW)') }}</span>
                      <span class="device-item-info-item-value">{{ group.eLinkSettingList[0].demandMax || 0 }}</span>
                    </div>
                    <div class="group-devices">
                      <div class="device-item" v-for="(device, deviceIndex) in (group.eLinkSettingList || [])"
                        :key="deviceIndex">
                        <div class="device-item-info">
                          <!-- elink1，elink2分别需量 -->
                          <div class="device-item-info-item">
                            <span class="device-item-info-item-label">{{ $str.getKey('策略控制/eLink标识') }}</span>
                            <span class="device-item-info-item-value">{{ device.uuid || 0 }}</span>
                          </div>
                          <div class="device-item-info-item">
                            <span class="device-item-info-item-label">{{ $str.getKey('策略控制/需量') }}</span>
                            <span class="device-item-info-item-value">{{ device.demandMax || 0 }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 右侧：配置信息 -->
                  <div class="demand-config">
                    <!-- 上面：动态需量预留值 -->
                    <div class="config-item">
                      <div class="config-input-row">
                        <div class="config-label">{{ $str.getKey('策略控制/动态需量预留值') }}</div>
                        <div class="config-input">
                          <el-tooltip v-if="!group.reserveDiff.same" effect="dark" placement="top">
                            <template #content>
                              <div v-for="item in group.reserveDiff.values" :key="item.uuid">
                                {{ item.uuid }}: {{ item.value }}
                              </div>
                            </template>
                            <el-input-number v-model="group.eLinkSettingList[0].reserveValue" :min="0" :max="999999"
                              :precision="0" :controls="false" :placeholder="$str.getKey('策略控制/请输入预留值')"
                              @change="validateInput($event, 'reserve', group.eLinkSettingList[0])"
                              class="diff-month" />
                          </el-tooltip>
                          <el-input-number v-else v-model="group.eLinkSettingList[0].reserveValue" :min="0"
                            :max="999999" :precision="0" :controls="false" :placeholder="$str.getKey('策略控制/请输入预留值')"
                            @change="validateInput($event, 'reserve', group.eLinkSettingList[0])" />
                          <div class="input-tip">
                            <el-icon class="tip-icon">
                              <InfoFilled />
                            </el-icon>
                            <span class="tip-text">{{ $str.getKey('策略控制/预留一部功率,以防超出动态需量最大值') }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- 下面：动态需量起始值 -->
                    <div class="config-item">
                      <div class="config-label">{{ $str.getKey('策略控制/动态需量起始值') }}
                        <!-- 提示语 -->
                        <div class="input-tip">
                          <el-icon class="tip-icon">
                            <InfoFilled />
                          </el-icon>
                          <span class="tip-text">{{ $str.getKey('策略控制/当月的需量值需要在储能投运前合理设置') }}</span>
                        </div>
                      </div>
                      <div class="config-input monthly-values">
                        <!-- 月份标签行 -->
                        <div class="month-labels-row">
                          <span class="month-label" v-for="month in 12" :key="`label-${month}`"
                            :class="{ 'diff-month': group.monthDiff && group.monthDiff[month - 1] && !group.monthDiff[month - 1].same }">
                            <el-tooltip v-if="group.monthDiff && group.monthDiff[month - 1]" effect="dark"
                              placement="top">
                              <template #content>
                                <div v-for="item in group.monthDiff[month - 1].values" :key="item.uuid">
                                  {{ item.uuid }}: {{ item.value }}
                                </div>
                              </template>
                              <span v-if="isZh">{{ month + '月' }}</span>
                              <span v-else>{{ getMonthEn(month) }}</span>
                            </el-tooltip>
                            <template v-else>
                              <span v-if="isZh">{{ month + '月' }}</span>
                              <span v-else>{{ getMonthEn(month) }}</span>
                            </template>
                          </span>
                        </div>
                        <!-- 月份输入框行 -->
                        <div class="month-inputs-row">
                          <el-input-number v-for="month in 12" :key="`input-${month}`"
                            v-model="group.eLinkSettingList[0].monthlyArr[month - 1]" :min="0" :max="999999"
                            :precision="0" :controls="false" @change="val => handleMonthInput(val, group, month - 1)"
                            placeholder="" />
                        </div>
                      </div>
                    </div>

                    <!-- 每个卡片的保存按钮 -->
                    <div class="demand-actions">
                      <el-button type="primary" @click="saveGroupSettings(group, groupIndex)">{{
                        $str.getKey('策略控制/保存设置')
                        }}</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 无分组数据时显示空状态 -->
            <el-empty class="empty-card" v-if="groupedElinkList.length === 0" :image="noDataIcon"
              :description="$str.getKey('策略控制/暂无分组数据')"></el-empty>
          </div>
        </div>

        <!-- 左下：通信中断储能运行模式 -->
        <div class="section-card" v-if="isDeveloper">
          <div class="section-title">{{ $str.getKey('策略控制/通信中断储能运行模式') }}</div>
          <div class="section-content">
            <div class="communication-mode-container">
              <div class="mode-selection">
                <div class="mode-options">
                  <el-radio-group v-model="formData.communicationMode" class='mode-radio-group'>
                    <el-radio :label="1">{{ $str.getKey('策略控制/按策略一直运行') }}</el-radio>
                    <el-radio :label="2">{{ $str.getKey('策略控制/按策略运行第二天停机') }}</el-radio>
                    <el-radio :label="3">{{ $str.getKey('策略控制/按策略工作休息制度运行') }}</el-radio>
                  </el-radio-group>
                  <el-button type="primary" @click="saveCommunicationMode">{{ $str.getKey('策略控制/保存运行模式') }}</el-button>
                </div>

                <div class="mode-description">
                  <template v-if="formData.communicationMode === 1">
                    <div class="subtitle">{{ $str.getKey('策略控制/按策略一直运行说明') }}</div>
                    <div class="desc-text">{{ $str.getKey('策略控制/通信中断时，储能设备将按最后一次下发的策略持续运行，直到通信恢复为止。') }}</div>
                  </template>
                  <template v-else-if="formData.communicationMode === 2">
                    <div class="subtitle">{{ $str.getKey('策略控制/按策略运行第二天停机说明：') }}</div>
                    <div class="desc-text">{{ $str.getKey('策略控制/通信中断时，储能设备将按最后一次下发的策略运行至第二天（00:10）后0功率停机，等待通信恢复。') }}
                    </div>
                  </template>
                  <template v-else>
                    <div class="subtitle">{{ $str.getKey('策略控制/按策略工作休息制度运行说明') }}</div>
                    <div class="desc-text">
                      {{ $str.getKey('策略控制/通信中断时，储能设备将按照工作日/休息日的设置运行') }}<br />
                      <div class="sub-item">
                        <div class="sub-item-title">{{ $str.getKey('策略控制/① 无休模式') }}</div>
                        <div class="sub-item-desc">{{ $str.getKey('策略控制/通信超时后，按策略一直运行。') }}</div>
                      </div>
                      <div class="sub-item">
                        <div class="sub-item-title">{{ $str.getKey('策略控制/② 单休模式') }}</div>
                        <div class="sub-item-desc">
                          - {{ $str.getKey('策略控制/周一至周六期间通信中断：按策略运行到本周日（00:10）后0功率停机。') }}<br />
                          - {{ $str.getKey('策略控制/周日当天通信中断：按策略运行到下周一（00:10）后0功率停机。') }}
                        </div>
                      </div>
                      <div class="sub-item">
                        <div class="sub-item-title">{{ $str.getKey('策略控制/③ 双休模式') }}</div>
                        <div class="sub-item-desc">
                          - {{ $str.getKey('策略控制/周一至周五期间通信中断：按策略运行到本周六（00:10）后0功率停机。') }}<br />
                          - {{ $str.getKey('策略控制/周六当天通信中断：按策略运行到下周一（00:10）后0功率停机。') }}
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧：操作历史 -->
      <div class="right-panel">
        <div class="section-title">{{ $str.getKey('策略控制/高级配置操作历史') }}</div>
        <el-timeline class="ac-history-timeline">
          <el-timeline-item v-for="(log, logIndex) in strategyLogList" :key="log.createTime" :timestamp="log.createTime">
            <!-- 策略历史列表 -->
            <div class="card-container">
              <div class="item-container">
                <span class="title">{{ $str.getKey('策略控制/操作人：') }}</span>
                <span class="content">{{ log.createBy }}</span>
              </div>
              <div class="item-container">
                <span class="title">{{ $str.getKey('策略控制/操作内容：') }}</span>
                <div class="content">
                  <!-- 需量操作：默认收起，点击「详情」展开完整内容 -->
                  <template v-if="isDemandOperation(log.modifiedContent)">
                    <el-button link type="primary" size="small" class="history-detail-toggle"
                      @click="toggleHistoryExpand(logIndex)">
                      {{ expandedHistory.has(logIndex) ? $str.getKey('策略控制/收起') : $str.getKey('策略控制/详情') }}
                    </el-button>
                    <div v-show="expandedHistory.has(logIndex)" class="demand-operation-content">
                      <DemandOperationList :data="parseDemandContent(log.modifiedJson)" />
                    </div>
                  </template>
                  <!-- 其他操作正常显示 -->
                  <span v-else>{{ log.modifiedContent }}</span>
                </div>
              </div>
            </div>

          </el-timeline-item>
        </el-timeline>
        <el-empty class="empty-card" v-if="strategyLogList.length === 0" :image="noDataIcon"
          :description="$str.getKey('策略控制/暂无数据')"></el-empty>
      </div>
    </div>


    <!-- 添加权限校验确认弹窗 -->
    <auth-verify-dialog v-model:visible="authDialogVisible" :stationId="stationId" :isAuth="isAuth"
      :phoneNumber="phoneNumber" @cancel="cancelAuthDialog" @confirm="onConfirmWithCode" />
  </div>

</template>

<script setup>
import { ref, reactive, onMounted, computed, watch, onUnmounted, nextTick } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import * as strategyApi from '../StrategyController/api.js'
import { getElinkStruct } from '@/api/device/elink'
import useAppStore from "@/store/modules/app"
import useUserStore from "@/store/modules/user"
import AuthVerifyDialog from '../StrategyController/components/AuthVerifyDialog.vue'
import DemandOperationList from './components/demand-operation-list.vue'
import noDataIcon from "@/assets/production/noData.png";
import { InfoFilled } from '@element-plus/icons-vue'
import { checkPermi } from '@/utils/permission'
import { saveSmsCode, clearSmsCode, getSavedSmsCode } from '../StrategyController/smsCodeStore'
const $str = window.$str;

const appStore = useAppStore()
const userStore = useUserStore()
const stationId = computed(() => appStore.stationId)

const eLinkList = ref([])
const groupedElinkList = ref([])
const selectedELinkId = ref('')
const antiRefluxLoading = ref(false)
const uuidList = ref([])
const verificationCode = ref('')

// 操作历史：记录哪些条目已展开（需量操作详情默认收起）
const expandedHistory = ref(new Set())
function toggleHistoryExpand(index) {
  const set = new Set(expandedHistory.value)
  if (set.has(index)) {
    set.delete(index)
  } else {
    set.add(index)
  }
  expandedHistory.value = set
}

// 表单数据
const formData = reactive({
  demand: 0,
  reactiveMode: 1, // 1-不出无功, 2-无功优先, 3-有功优先
  antiReflux: false,
  communicationMode: 1 // 1-按策略一直运行, 2-按策略运行第二天停机, 3-按策略工作休息制度运行
})

// 参数设置表单
const paramForm = reactive({
  transformerRatio: 0
})

/** 箱变容量变比：勾选要下发的 eLink，默认选中第一个 */
const selectedRatioElinks = ref([])

/** 电站参数设置返回的 eLink 变比列表（uuid + transfCapRatio） */
const stationSettingElinks = ref([])

/** 电站实际的 eLink 设备台账（与是否分组无关，无分组时也有数据） */
const stationElinks = ref([])

async function loadStationElinks() {
  try {
    const res = await getElinkStruct(stationId.value)
    stationElinks.value = res?.data || []
  } catch (error) {
    stationElinks.value = []
  }
}

/**
 * eLink 下拉选项。
 * 取值优先级（取第一个非空的）：
 *   1. 设备台账 /device/elink/eLinkList/{stationId}——按电站实际设备返回，与是否分组无关，最准；
 *   2. 分组设置 groupSettingList；
 *   3. 电站参数设置 getStationSetting；
 *   4. 策略侧 /strategy/api/station/elinks——兜底，保证任何情况下不为空
 *      （该接口条数可能多于实际设备，仅在前三者都取不到时才用）。
 * 名称统一从台账的 equipmentName / 策略侧的 elink_name 里找，找不到就显示 uuid。
 */
const elinkOptions = computed(() => {
  const nameMap = new Map()
  stationElinks.value.forEach(item => {
    if (item?.uuid && item.equipmentName) nameMap.set(item.uuid, item.equipmentName)
  })
  eLinkList.value.forEach(item => {
    if (item?.elink_id && item.elink_name && !nameMap.has(item.elink_id)) {
      nameMap.set(item.elink_id, item.elink_name)
    }
  })

  const fromDevice = stationElinks.value.map(item => item?.uuid)
  const fromGroups = groupedElinkList.value
    .flatMap(group => group.eLinkSettingList || [])
    .map(item => item?.uuid)
  const fromSetting = stationSettingElinks.value.map(item => item?.uuid)
  const fromStrategy = eLinkList.value.map(item => item?.elink_id)

  const ids = [fromDevice, fromGroups, fromSetting, fromStrategy]
    .map(list => list.filter(Boolean))
    .find(list => list.length > 0) || []

  const map = new Map()
  ids.forEach(id => {
    if (!map.has(id)) map.set(id, { uuid: id, label: nameMap.get(id) || id })
  })
  return [...map.values()]
})

// 选项加载完成后默认选中第一个；已有选择则保留，并剔除已失效的 uuid
watch(elinkOptions, (list) => {
  const ids = list.map(item => item.uuid)
  const kept = selectedRatioElinks.value.filter(id => ids.includes(id))
  if (kept.length !== selectedRatioElinks.value.length) {
    selectedRatioElinks.value = kept
  }
  if (kept.length === 0 && ids.length > 0) {
    selectedRatioElinks.value = [ids[0]]
  }
}, { immediate: true })

// 用于存储操作前的原始值
const originalValues = reactive({
  reactiveMode: 1,
  transformerRatio: 0
})

// 当前正在修改无功工作模式的分组上下文
// uuidList 只装这一组的 eLink，避免把改动下发到全站
const currentReactiveTarget = ref(null)

// uuid -> 后端已生效的 reactiveMode，用于失败/取消时回滚下拉框
const reactiveModeSnapshot = new Map()

// 语言判断走 $str.getLanguage()：localStorage 无 language 键时它默认 'cn'，
// 直接读 localStorage 会得到 null 而误判成英文
const isZh = computed(() => $str.getLanguage() === 'cn')

// 表单引用
const formRef = ref(null)
const paramFormRef = ref(null)

// 权限校验弹窗控制
const authDialogVisible = ref(false)
const pendingOperation = ref(null)

// 自动需量相关数据
const isAutoDemandOpen = ref(false)

const inputTemp = ref([]) // 新增：不一致时的输入框内容

// getAuthConfig 必须先完成：它负责填充 phoneNumber，
// 而 isVerificationValid() 要拿 phoneNumber 去校验，
// 并发时会用空手机号发起校验并误判验证码失效。
// 其余接口互不依赖，用 allSettled 并发：任何一个失败都不能中断其余的加载。
async function loadAll() {
  await getAuthConfig().catch(() => { })
  await Promise.allSettled([
    loadGroupList(),
    loadELinks(),
    loadStationElinks(),
    getGroupSettingRecord(),
    getStationSetting(),
  ])
}

// 初始化函数
onMounted(async () => {
  await loadAll()
  if (eLinkList.value.length > 0) {
    selectedELinkId.value = eLinkList.value[0].uuid
    // uuidList.value = eLinkList.value.map(item => item.elink_id)
  }

  // 初始化时只判断本地有没有未过期的验证码，不做后端校验。
  // 之前这里会调 isVerificationValid() 发请求，用户什么都没操作就被提示「验证码无效」；
  // 真正的校验推迟到用户执行高风险操作时进行（见 saveReactiveMode / saveTransformerRatio）。
  // getSavedSmsCode() 内部会顺带清理已过期（超过 5 分钟）的验证码，
  // 并要求验证码归属于当前电站的手机号，否则视为不可用。
  verificationCode.value = getSavedSmsCode(phoneNumber.value)
})
async function getStationSetting() {
  try {
    const res = await strategyApi.getStationSetting(stationId.value)
    const list = res?.code === 200 && Array.isArray(res.data?.eLinkSettingList)
      ? res.data.eLinkSettingList
      : []
    stationSettingElinks.value = list
    paramForm.transformerRatio = list.length > 0 ? list[0].transfCapRatio : 0.5
  } catch (error) {
    stationSettingElinks.value = []
    paramForm.transformerRatio = 0.5
  }
}

// 在组件卸载时清除计时器
onUnmounted(() => {
  // 清理工作
})

watch(stationId, async () => {
  await loadAll()
})

// 加载组列表
async function loadGroupList() {
  // 无分组的电站该接口可能返回非数组或非 200，这里必须自己兜住：
  // 之前没有 try/catch，它一抛异常就会中断 onMounted 里后续的 loadELinks/loadStationElinks，
  // 导致 eLink 下拉的几个数据源全是空的。
  let res
  try {
    res = await strategyApi.getGroupSettingList(stationId.value)
  } catch (error) {
    groupedElinkList.value = []
    return
  }
  if (res && Array.isArray(res.data)) {
    groupedElinkList.value = res.data.map((group, groupIdx) => {
      // 1. 解析每个elink的monthlyArr和reserveValue
      const eLinkSettingList = (group.eLinkSettingList || [])
        .filter(e => !!e && typeof e === 'object')
        .map(elink => {
          let monthlyArr = [];

          // 修正 monthly 数据解析逻辑
          if (elink.monthly) {
            if (Array.isArray(elink.monthly)) {
              // 新格式：直接是数组
              monthlyArr = [...elink.monthly];
            } else if (typeof elink.monthly === 'string') {
              // 旧格式：JSON字符串，需要解析
              try {
                const monthlyObj = JSON.parse(elink.monthly);
                if (Array.isArray(monthlyObj)) {
                  // 解析出来就是数组，直接赋值
                  monthlyArr = [...monthlyObj];
                } else if (typeof monthlyObj === 'object') {
                  // 兼容对象格式（如 {1:100,2:200,...}）
                  for (let i = 1; i <= 12; i++) {
                    monthlyArr.push(Number(monthlyObj[i] || 0));
                  }
                }
              } catch {
                // 解析失败，使用默认值
                monthlyArr = new Array(12).fill(0);
              }
            }
          }

          // 确保数组长度为12
          while (monthlyArr.length < 12) {
            monthlyArr.push(0);
          }
          monthlyArr = monthlyArr.slice(0, 12); // 截取前12个元素

          return { ...elink, monthlyArr, reserveValue: Number(elink.protectiveValue || 0) };
        });

      // 数据兜底，保证第一个elink的monthlyArr有12个元素
      if (eLinkSettingList[0]) {
        if (!eLinkSettingList[0].monthlyArr) eLinkSettingList[0].monthlyArr = [];
        for (let i = 0; i < 12; i++) {
          if (typeof eLinkSettingList[0].monthlyArr[i] === 'undefined') eLinkSettingList[0].monthlyArr[i] = 0;
        }
      }

      // 2. 计算每月是否一致
      const monthDiff = [];
      for (let i = 0; i < 12; i++) {
        const vals = eLinkSettingList.map(e => e.monthlyArr[i]);
        const allSame = vals.length > 0 ? vals.every(v => v === vals[0]) : true;
        monthDiff.push({
          same: allSame,
          values: eLinkSettingList.map(e => ({ uuid: e.uuid, value: e.monthlyArr[i] }))
        });
      }
      while (monthDiff.length < 12) {
        monthDiff.push({ same: true, values: [] });
      }

      // 3. 计算预留值是否一致
      const reserveVals = eLinkSettingList.map(e => e.reserveValue);
      const reserveSame = reserveVals.every(v => v === reserveVals[0]);
      const reserveDiff = {
        same: reserveSame,
        values: eLinkSettingList.map(e => ({ uuid: e.uuid, value: e.reserveValue }))
      };

      return { ...group, eLinkSettingList, monthDiff, reserveDiff };
    });
  } else {
    groupedElinkList.value = []
  }
  syncReactiveModeSnapshot()
}

// 记录后端返回的无功工作模式，作为回滚基准
// （v-model 会在 change 触发前就改掉视图上的值，拿不到旧值）
function syncReactiveModeSnapshot() {
  reactiveModeSnapshot.clear()
  groupedElinkList.value.forEach(group => {
    (group.eLinkSettingList || []).forEach(elink => {
      if (elink?.uuid) reactiveModeSnapshot.set(elink.uuid, elink.reactiveMode)
    })
  })
}

// 加载eLink列表
async function loadELinks() {
  getGroupSettingRecord()
  try {
    const res = await strategyApi.elinks(stationId.value)
    // 必须确认是数组：eLinkList 会被 elinkOptions 直接 .map，拿到对象会让整个 computed 报错
    eLinkList.value = Array.isArray(res?.data) ? res.data : []
    if (eLinkList.value.length > 0) {
      formData.communicationMode = Number(eLinkList.value[0].comm_timeout_stop_mode) || 1
    }
  } catch (error) {
    eLinkList.value = []
    ElMessage.info($str.getKey('策略控制/elink分组为空'))
  }
}

const phoneNumber = ref('')
const preventCounterCurrent = ref(0)
const transformerCapacityRatio = ref(0)
const reactivePowerWorking = ref(0)
const isAuth = ref(false)
const autoDemand = ref(0)
async function getAuthConfig() {
  await strategyApi.getStationStrategyConfig(stationId.value).then(res => {
    if (res.code == 200 && res.data) {
      // 显示权限校验弹窗
      phoneNumber.value = res.data.phoneNumber
      preventCounterCurrent.value = res.data.preventCounterCurrent
      transformerCapacityRatio.value = res.data.transformerCapacityRatio
      reactivePowerWorking.value = res.data.reactivePowerWorking
      autoDemand.value = res.data.autoDemand
      isAutoDemandOpen.value = res.data.autoDemand == 0 ? false : res.data.autoDemand == 1 ? true : false
    } else {
      isAuth.value = false
    }
  })
}


// 无功工作模式变更处理
async function onReactiveModeChange(elinkSetting) {
  // 添加安全检查
  if (!elinkSetting || !elinkSetting.length || !elinkSetting[0]) {
    ElMessage.warning($str.getKey('策略控制/无效的eLink设置'))
    return
  }

  // 只取本分组的 eLink，下发范围严格限定在这一组
  const groupUuidList = elinkSetting.map(e => e?.uuid).filter(Boolean)
  if (!groupUuidList.length) {
    ElMessage.warning($str.getKey('策略控制/无效的eLink设置'))
    return
  }

  // 待下发的新值 = v-model 已经写入的值；回滚基准从快照取
  originalValues.reactiveMode = reactiveModeSnapshot.has(groupUuidList[0])
    ? reactiveModeSnapshot.get(groupUuidList[0])
    : elinkSetting[0].reactiveMode
  currentReactiveTarget.value = {
    elinkSetting,
    uuidList: groupUuidList,
    mode: elinkSetting[0].reactiveMode
  }

  isAuth.value = reactivePowerWorking.value
  if (reactivePowerWorking.value) {
    // 检查验证码是否有效
    const isValid = await isVerificationValid()
    if (isValid) {
      // 验证码有效，直接执行保存操作
      await saveReactiveMode()
      return
    }

    // 验证码无效，显示权限校验弹窗
    authDialogVisible.value = true
    pendingOperation.value = 'saveReactiveMode'
  } else {
    // 没有权限，恢复原始值
    rollbackReactiveMode()
    currentReactiveTarget.value = null
    // 显示权限校验弹窗
    authDialogVisible.value = true
  }
}

// 把本组下拉框恢复成后端已生效的值
function rollbackReactiveMode() {
  const target = currentReactiveTarget.value
  if (!target) return
  target.elinkSetting.forEach(elink => {
    if (elink) elink.reactiveMode = originalValues.reactiveMode
  })
}

// 保存通信中断运行模式
async function saveCommunicationMode() {
  uuidList.value = [];
  eLinkList.value.forEach(item => {
    uuidList.value.push(item.elink_id)
  })
  const saveData = {
    stationId: stationId.value,
    uuidList: uuidList.value,
    commTimeoutStopMode: String(formData.communicationMode),
  }

  // 直接调用API，无需验证码
  const res = await strategyApi.updateGroupSetting(saveData)
  if (res.code === 200) {
    ElMessage.success($str.getKey('策略控制/通信中断运行模式保存成功'))
    await loadELinks()
  } else {
    ElMessage.error(res.msg || $str.getKey('策略控制/保存失败'))
  }

}

// 保存参数设置
async function saveParamSettings() {
  // 保存操作前的原始值
  originalValues.transformerRatio = paramForm.transformerRatio
  isAuth.value = transformerCapacityRatio.value
  if (transformerCapacityRatio.value) {
    // 检查验证码是否有效
    const isValid = await isVerificationValid()
    if (isValid) {
      // 验证码有效，直接执行保存操作
      await saveTransformerRatio()
      return
    }

    // 验证码无效，显示权限校验弹窗
    authDialogVisible.value = true
    pendingOperation.value = 'saveParams'
  } else {
    // 没有权限，恢复原始值
    paramForm.transformerRatio = originalValues.transformerRatio
    // 显示权限校验弹窗
    authDialogVisible.value = true
  }
}

// 确认权限校验弹窗 - 修改此函数处理权限校验成功后的逻辑
async function confirmAuthDialog() {
  authDialogVisible.value = false

  // 根据不同的操作类型执行相应的保存逻辑
  if (pendingOperation.value === 'saveParams') {
    // 保存箱变容量变比
    await saveTransformerRatio()
  } else if (pendingOperation.value === 'saveReactiveMode') {
    // 保存无功工作模式
    await saveReactiveMode()
  }

  // 清除操作状态
  pendingOperation.value = null
  currentReactiveTarget.value = null
}

// 保存无功工作模式
async function saveReactiveMode() {
  // 获取当前存储的验证码（已过期、或不属于当前手机号的会返回空串）
  let smsCode = getSavedSmsCode(phoneNumber.value)

  // 验证验证码是否有效
  const isValid = await isVerificationValid()
  if (!isValid) {
    // 验证码无效，显示验证弹窗
    authDialogVisible.value = true
    return
  }
  const target = currentReactiveTarget.value
  if (!target) {
    ElMessage.warning($str.getKey('策略控制/无效的eLink设置'))
    return
  }

  try {
    const saveData = {
      stationId: stationId.value,
      uuidList: target.uuidList, // 只下发当前修改的这一组 eLink
      reactiveMode: target.mode
    }

    const res = await strategyApi.updateGroupSetting(saveData, smsCode)

    if (res.code === 200) {
      ElMessage.success($str.getKey('策略控制/无功工作模式保存成功'))
      // 下发成功后刷新分组数据，同时更新回滚快照
      await loadGroupList()
      await loadELinks()
      // 操作成功，无需清除验证码
    } else {
      ElMessage.error(res.msg || $str.getKey('策略控制/保存失败'))
      // 恢复原始值
      rollbackReactiveMode()
      if (res.code === 401 || res.msg?.includes('验证码')) {
        // 验证码失效，清除本地存储的验证码
        clearSmsCode()
        authDialogVisible.value = true
      }
    }
  } catch (error) {
    console.error($str.getKey('策略控制/保存无功工作模式失败'), error)
    ElMessage.error($str.getKey('策略控制/保存失败: ') + (error.message || $str.getKey('策略控制/未知错误')))
    // 恢复原始值
    rollbackReactiveMode()
  }
}

// 保存箱变容量变比
async function saveTransformerRatio() {
  // 获取当前存储的验证码（已过期、或不属于当前手机号的会返回空串）
  let smsCode = getSavedSmsCode(phoneNumber.value)

  // 验证验证码是否有效
  const isValid = await isVerificationValid()
  if (!isValid) {
    // 验证码无效，显示验证弹窗
    authDialogVisible.value = true
    return
  }
  // 只下发勾选的 eLink；未勾选时保持原行为，下发全部
  uuidList.value = selectedRatioElinks.value.length > 0
    ? [...selectedRatioElinks.value]
    : elinkOptions.value.map(item => item.uuid)

  try {
    const saveData = {
      stationId: stationId.value,
      uuidList: uuidList.value,
      transfCapRatio: paramForm.transformerRatio
    }

    const res = await strategyApi.updateGroupSetting(saveData, smsCode)

    if (res.code === 200) {
      ElMessage.success($str.getKey('策略控制/箱变容量变比保存成功'))
      await loadELinks()
      setTimeout(() => {
        getStationSetting()
      }, 3000);

      // 操作成功，无需清除验证码
    } else {
      ElMessage.error(res.msg || $str.getKey('策略控制/保存失败'))
      // 恢复原始值
      paramForm.transformerRatio = originalValues.transformerRatio
      if (res.code === 401 || res.msg?.includes('验证码')) {
        // 验证码失效，清除本地存储的验证码
        clearSmsCode()
        authDialogVisible.value = true
      }
    }
  } catch (error) {
    console.error($str.getKey('策略控制/保存箱变容量变比失败'), error)
    ElMessage.error($str.getKey('策略控制/保存失败: ') + (error.message || $str.getKey('策略控制/未知错误')))
    // 恢复原始值
    paramForm.transformerRatio = originalValues.transformerRatio
  }
}
// 移除基于时间戳的验证相关函数
// getSavedSmsCode / saveSmsCode / clearSmsCode 已收敛到 ../StrategyController/smsCodeStore
// 检查验证码是否有效的函数
// 返回 true=有效 / false=确认无效 / null=无法判定（手机号未就绪或请求异常）
// null 与 false 必须区分：调用方据此决定「是否清除本地验证码」，
// 无法判定时清除会把本来有效的验证码误删。
async function isVerificationValid() {
  // 手机号守卫必须在取码之前：getSavedSmsCode 需要手机号来判断归属，
  // 手机号未就绪时取不到码，若先取码会误判为 false(确认无效)而丢掉 null(无法判定)语义
  if (!phoneNumber.value) {
    return null
  }
  // 本地已过期、或验证码不属于当前手机号时直接判定无效，不必发请求
  const code = getSavedSmsCode(phoneNumber.value)
  if (!code) {
    return false
  }
  try {
    const res = await strategyApi.checkSmsCodeSilent({
      phoneNumber: phoneNumber.value,
      smsCode: code
    })
    return res.code === 200
  } catch (error) {
    console.error('验证码检查失败', error)
    return null
  }
}

// 处理带验证码的确认逻辑
function onConfirmWithCode(code) {
  // 保存验证码
  verificationCode.value = code

  // 保存到localStorage中，记录写入时间（5 分钟过期的计时起点）与所属手机号
  saveSmsCode(phoneNumber.value, code)

  // 关闭弹窗
  authDialogVisible.value = false

  // 执行确认逻辑
  confirmAuthDialog()
}

// 获取无功工作模式文本
function getReactiveModeText(mode) {

  const modeMap = {
    0: '不出无功',
    1: '不出无功',
    2: '优先出无功',
    3: '优先出有功'
  }
  return modeMap[mode] || '未知'
}

// 取消权限校验弹窗
function cancelAuthDialog() {
  authDialogVisible.value = false

  // 如果取消权限验证，恢复原始值
  if (pendingOperation.value === 'saveReactiveMode') {
    rollbackReactiveMode()
  } else if (pendingOperation.value === 'saveParams') {
    paramForm.transformerRatio = originalValues.transformerRatio
  }

  pendingOperation.value = null
  currentReactiveTarget.value = null
}


// 获取高级配置操作日志
async function getGroupSettingRecord() {
  const res = await strategyApi.getGroupSettingRecord({
    page: 1,
    pageSize: 99999,
    stationId: stationId.value
  })
  if (res && res.rows) {
    strategyLogList.value = res.rows
  }
}

const strategyLogList = ref([])

/**
 * 通信中断储能运行模式：仅对勾选了该菜单权限的角色开放。
 * 原先按角色名硬编码（user/test-1/software/admin 等），新增角色需改代码；
 * 现改为菜单权限控制，由系统管理 > 角色管理勾选决定。
 */
const isDeveloper = computed(() => checkPermi(['ops:advancedMode:commInterruptMode']))

// 输入验证函数
const validateInput = (value, type, elink, monthIndex) => {
  if (value === null || value === '') return

  const numValue = Number(value)
  if (isNaN(numValue)) {
    ElMessage.warning($str.getKey('策略控制/请输入有效的数字'))
    return false
  }

  if (numValue < 0 || numValue > 999999) {
    ElMessage.warning($str.getKey('策略控制/输入值必须在0-999999之间'))
    if (type === 'reserve') {
      elink.reserveValue = null
    } else if (type === 'monthly') {
      elink.monthlyArr[monthIndex] = null
    }
    return false
  }

  // 如果是小数，自动取整
  if (numValue % 1 !== 0) {
    const intValue = Math.floor(numValue)
    ElMessage.info($str.getKey('策略控制/已自动取整'))
    if (type === 'reserve') {
      elink.reserveValue = intValue
    } else if (type === 'monthly') {
      elink.monthlyArr[monthIndex] = intValue
    }
  }

  return true
}

// 保存单个分组的设置
const saveGroupSettings = async (group, groupIndex) => {
  // 验证所有输入
  const firstElink = group.eLinkSettingList[0]
  if (!validateInput(firstElink.reserveValue, 'reserve', firstElink)) {
    ElMessage.warning($str.getKey('策略控制/请检查动态需量预留值'))
    return
  }

  for (let i = 0; i < 12; i++) {
    if (firstElink.monthlyArr[i] !== null && !validateInput(firstElink.monthlyArr[i], 'monthly', firstElink, i)) {
      ElMessage.warning($str.getKey('策略控制/请检查') + (i + 1) + $str.getKey('策略控制/月的动态需量起始值'))
      return
    }
  }

  try {
    // 准备保存数据 - 修改monthly为数组格式
    const monthly = [];
    for (let i = 0; i < 12; i++) {
      monthly[i] = Number(firstElink.monthlyArr[i] ?? 0);
    }
    const params = {
      stationId: stationId.value,
      groupIndex: group.groupIndex,
      uuidList: group.eLinkSettingList.map(e => e.uuid),
      monthly, // 现在是一个包含12个元素的数组
      protectiveValue: firstElink.reserveValue,
      autoSwitch: autoDemand.value
    };

    // 调用API保存设置
    console.log($str.getKey('策略控制/保存数据:'), params)
    const res = await strategyApi.updateAutoDemandConfig(params)
    console.log($str.getKey('策略控制/保存结果:'), res)
    await setAutoDemand()
    await getGroupSettingRecord()
    setTimeout(() => {
      getAutoDemandConfig(res.data)
    }, 3000);
    ElMessage.success($str.getKey('策略控制/保存成功'))
  } catch (error) {
    ElMessage.error($str.getKey('策略控制/保存失败'))
    console.error(error)
  }
}
async function getAutoDemandConfig(sign) {
  const res = await strategyApi.getAutoDemandConfig(sign)
  try {
    if (res.data == 'OK') {
      ElMessage.success($str.getKey('策略控制/设备同步成功'))
    } else {
      ElMessage.error($str.getKey('策略控制/设备同步失败'))
    }
  } catch (error) {
    ElMessage.error($str.getKey('策略控制/设备同步失败'))
    console.error(error)
  }
}



async function setAutoDemand() {
  await strategyApi.updateAutoDemandValue(stationId.value, autoDemand.value)
}

// 切换自动需量开关
async function toggleAutoDemand(value) {
  if (value) {
    autoDemand.value = 1
    isAutoDemandOpen.value = true
  } else {
    autoDemand.value = 0
    isAutoDemandOpen.value = false
  }
  await setAutoDemand()
}

// 新增：批量同步输入
function handleMonthInput(val, group, monthIndex) {
  const num = Number(val)
  if (val === '' || isNaN(num)) {
    if (inputTemp.value[monthIndex]) inputTemp.value[monthIndex] = ''
    return
  }
  group.eLinkSettingList.forEach(elink => {
    elink.monthlyArr[monthIndex] = num
  })
  const vals = group.eLinkSettingList.map(e => e.monthlyArr[monthIndex])
  const allSame = vals.length > 0 ? vals.every(v => v === vals[0]) : true
  group.monthDiff[monthIndex] = {
    same: allSame,
    values: group.eLinkSettingList.map(e => ({ uuid: e.uuid, value: e.monthlyArr[monthIndex] }))
  }
  // 刷新inputTemp
  if (!allSame && inputTemp.value[monthIndex]) {
    inputTemp.value[monthIndex] = ''
  }
}

// 判断是否为需量操作
function isDemandOperation(content) {
  if (!content) return false
  return content.includes('自动需量') || content.includes('demand') || content.includes('monthly') || content.includes('protectiveValue')
}

// 解析需量操作内容
function parseDemandContent(content) {
  try {
    // 尝试解析JSON格式的内容
    if (typeof content === 'string') {
      return JSON.parse(content)
    }
    return content
  } catch (error) {
    console.error('解析需量内容失败:', error)
    // 如果解析失败，返回原始内容
    return { originalContent: content }
  }
}
function getMonthEn(index) {
  const monthEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return monthEn[index - 1]
}

</script>

<style lang="scss" scoped>
.advanced-config-container {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;

  .main-content {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 10px;

    .left-panel {
      flex: 7;
      display: flex;
      flex-direction: column;
      gap: 10px;
      height: 100%;
      // flex 布局下 min-width 默认 auto，内容会把左栏顶宽从而挤压右侧策略历史
      min-width: 0;
      overflow-y: auto;
      max-height: calc(100vh - 120px);

      .section-card {
        background: var(--level1-bg-color);
        border: 1px solid rgba(54, 62, 90, 0.7);
        border-radius: 6px;
        padding: 15px;


        // display: flex;
        // flex-flow: row;
        .section-title {
          border-left: 4px solid #485E91;
          padding-left: 16px;
          font-family: HelveticaNeue, HelveticaNeue;
          font-weight: bold;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 23px;
          text-align: left;
          margin-bottom: 20px;
        }

        .group-block-container {
          display: flex;
          flex-flow: row;
          overflow-x: auto;
          padding-bottom: 10px;

          &::-webkit-scrollbar {
            height: 6px;
          }

          &::-webkit-scrollbar-track {
            background: transparent;
          }

          &::-webkit-scrollbar-thumb {
            background: rgba(144, 147, 153, 0.4);
            border-radius: 3px;
          }

          &::-webkit-scrollbar-thumb:hover {
            background: rgba(144, 147, 153, 0.6);
          }

          .empty-card {
            margin-left: 50%;
          }
        }

        .group-block {
          background: #2E3648;
          border-radius: 8px;
          padding: 12px;
          margin-right: 20px;
          cursor: pointer;
          transition: all 0.3s;
          border: 1px solid transparent;
          display: flex;
          flex-direction: column;

          &:hover:not(.active) {
            background: rgb(79 103 233 / 59%);
            box-shadow: 0px 4px 14.5px 0px rgba(81, 101, 225, 1);
          }

          .card-header {
            display: flex;
            align-items: center;
            margin-bottom: 16px;

            .card-index {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 24px;
              height: 24px;
              background: #fff;
              color: #4e73ff;
              border-radius: 50%;
              font-weight: bold;
              font-size: 14px;
              margin-right: 10px;
            }

            .group-name {
              font-weight: bold;
              font-size: 15px;
              color: #FFFFFF;
            }
          }

          .card-body {
            padding: 5px;

            .section-subtitle {
              font-size: 14px;
              font-weight: bold;
              color: #97A0B7;
              margin-bottom: 15px;
              padding-bottom: 5px;
              border-bottom: 1px dashed rgba(54, 62, 90, 0.5);
            }

            .elink-details {
              background: rgba(30, 38, 58, 0.3);
              border-radius: 6px;
              padding: 16px;
              box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
              margin-bottom: 15px;

              .elink-list-section {
                display: flex;
                flex-flow: row;

                .elink-list-section-card {
                  margin-bottom: 10px;
                  background: transparent;
                  border: none;

                  &:last-child {
                    margin-bottom: 0;
                  }

                  :deep(.el-card__body) {
                    padding: 10px 0;
                  }
                }

                .detail-item {
                  display: flex;
                  margin-bottom: 8px;

                  &:last-child {
                    margin-bottom: 0;
                  }

                  .item-label {
                    width: 100px;
                    text-align: right;
                    padding-right: 10px;
                    color: #97A0B7;
                    flex-shrink: 0;
                  }

                  .item-value {
                    flex: 1;
                    text-align: left;
                    color: #FFFFFF;
                  }
                }
              }
            }

            .group-settings-section {
              margin-top: 15px;
              background: rgba(30, 38, 58, 0.3);
              border-radius: 6px;
              padding: 16px;
              box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

              .setting-item {
                display: flex;
                margin-bottom: 16px;

                &:last-child {
                  margin-bottom: 0; // 最后一个设置项没有下边距
                }

                .setting-label {
                  font-size: 14px;
                  color: #97A0B7;
                  font-weight: 500;
                }

                .setting-control {
                  display: flex;
                  align-items: center;

                  .el-select {
                    width: 100%;
                  }

                  :deep(.el-switch) {
                    --el-switch-on-color: #576BFF;
                  }
                }

                // 水平布局（防逆流使用）
                &.horizontal-item {
                  flex-direction: row;
                  align-items: center;
                  justify-content: space-between;

                  .setting-label {
                    margin-right: 15px;
                    min-width: 80px;
                  }

                  .setting-control {
                    justify-content: flex-end;
                  }
                }

                // 垂直布局（无功工作模式使用）
                &.vertical-item {
                  flex-direction: column;

                  .setting-label {
                    margin-bottom: 10px;
                  }

                  .setting-control {
                    width: 100%;
                  }
                }
              }
            }
          }
        }

        .section-content {
          padding: 0 10px;
        }

        .button-container {
          display: flex;
          justify-content: flex-end;
          margin-top: 20px;
        }

      }

      .section-card-group {
        height: 60%;
      }
    }

    .right-panel {
      flex: 3;
      min-width: 320px;
      background: var(--level1-bg-color);
      border: 1px solid rgba(54, 62, 90, 0.7);
      border-radius: 6px;
      padding: 15px;
      height: 100%;
      overflow-y: auto;
      display: flex;
      flex-direction: column;

      .section-title {
        border-left: 4px solid #485E91;
        padding-left: 16px;
        font-family: HelveticaNeue, HelveticaNeue;
        font-weight: bold;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 23px;
        text-align: left;
        margin-bottom: 20px;
      }

      :deep(.page-container) {
        flex: 1;
        overflow: hidden;
      }
    }
  }

  .communication-mode-container {
    .mode-selection {
      background: #1F2536;
      border-radius: 8px;
      padding: 20px;

      .mode-options {
        margin-bottom: 20px;

        .el-radio {
          margin-right: 20px;
          margin-bottom: 10px;
          color: #D0D0D0;
        }

        .el-radio__input.is-checked+.el-radio__label {
          color: #409EFF;
        }

        .el-button {
          color: #ffffff;
        }
      }

      .mode-description {
        background: #2E3648;
        border-radius: 8px;
        padding: 16px;
        width: 100%;
        height: auto;
        overflow: auto;

        .subtitle {
          font-size: 14px;
          font-weight: bold;
          color: #FFFFFF;
          margin-bottom: 10px;
        }

        .desc-text {
          font-size: 13px;
          color: #97A0B7;
          line-height: 1.6;

          .sub-item {
            margin-top: 10px;

            .sub-item-title {
              font-weight: bold;
              color: #D0D0D0;
              margin-bottom: 4px;
            }

            .sub-item-desc {
              padding-left: 15px;
              margin-bottom: 8px;
            }
          }
        }
      }
    }
  }

  // 权限校验弹窗样式
  .auth-dialog-content {
    display: flex;
    background-color: #2E3648;
    border-radius: 8px;
    padding: 20px 30px;

    .auth-left {
      flex: 1;

      .phone-verify {
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid rgba(151, 160, 183, 0.2);

        .phone-input {
          display: flex;
          align-items: center;
          margin-bottom: 15px;

          .label {
            color: #D0D0D0;
            margin-right: 10px;
            min-width: 60px;
            line-height: 32px;
          }

          .value {
            color: #FFFFFF;
            font-weight: 500;
          }
        }

        .code-input {
          display: flex;
          margin-bottom: 15px;

          .label {
            line-height: 32px;
          }

          .code-field {
            flex: 1;
            margin-right: 10px;

            :deep(.el-input__inner) {
              background-color: #1F2536;
              border-color: #3A4157;
              color: #FFFFFF;
            }
          }

          .send-btn {
            min-width: 120px;
          }
        }

        .confirm-btn {
          display: flex;
          justify-content: flex-end;
          gap: 10px;

          .cancel-btn {
            margin-right: 10px;
          }
        }
      }
    }

    .auth-text {
      flex: 1;

      .auth-item {
        font-size: 14px;
        color: #D0D0D0;
        line-height: 1.8;
        margin-bottom: 10px;
        text-align: left;

        &:last-child {
          margin-top: 20px;
          color: #97A0B7;
          font-style: italic;
        }
      }
    }

    .auth-right {
      width: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  // 修改element-plus弹窗样式（浅色，跟随系统默认弹框风格）
  :deep(.el-dialog) {
    background-color: #ffffff;

    .el-dialog__header {
      margin: 0;
      padding: 15px 20px;
      background-color: #ffffff;

      .el-dialog__title {
        color: #2E2E2E;
        font-size: 16px;
        font-weight: bold;
      }
    }

    .el-dialog__body {
      padding: 20px;
      color: #2E2E2E;
    }

    .el-dialog__footer {
      padding: 10px 20px 20px;
    }
  }

  .confirm-btn {
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    .cancel-btn {
      margin-right: 10px;
    }
  }

  .phone-input {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .label {
      color: #D0D0D0;
      margin-right: 10px;
      min-width: 60px;
    }

    .value {
      color: #FFFFFF;
      font-weight: 500;
    }
  }
}

// 添加表单相关样式
.param-form {
  margin: 10px 0;

  :deep(.el-form-item) {
    margin-bottom: 20px;
  }

  .form-input-row {
    display: flex;
    align-items: center;
    gap: 20px;
    /* 输入框与按钮的间距 */

    .elink-select {
      width: 240px;
    }

    .transformer-ratio-input {
      width: 180px;
    }

    .save-btn {
      min-width: 100px;
      color: #ffffff;
    }
  }

  // 修改时间线的样式
  ::v-deep .timeline-dot-symbol {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 3px solid #687DFF !important;
    background: #1f2536;
  }

  ::v-deep .el-timeline-item__tail {
    color: #687DFF !important;
    --el-timeline-node-color: #687DFF !important;
    left: 7px;
    top: 15px;
    bottom: 16px;

  }

  .card-container {
    width: 100%;
    background-color: #1f2536;
    border-radius: 6px;
    padding: 10px;

    .item-container {
      width: 100%;
      display: flex;
      line-height: 30px;
      font-family: PingFang-SC, PingFang-SC;
      font-size: 14px;
      color: #FFFFFF;

      .title {
        width: 80px;
        text-align: right;
      }

      .content {
        width: 200px;
        flex: 1 1 auto;
        word-wrap: break-word;
        $normal-blue-color: #596eff;

        .demand-operation-content {
          width: 100%;
          max-width: 400px;
        }
      }
    }

  }

}

// 添加表格与表单左右布局样式
.param-form-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .param-form {
    flex: 1;
    margin-right: 20px;
    min-width: 250px;
  }
}

// 自动需量模块样式
.demand-modules-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;

  // 自动需量开关样式
  .auto-demand-switch {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
    padding: 10px;
    background: rgba(43, 87, 238, 0.04);
    border-radius: 6px;

    .switch-label {
      font-size: 14px;
      color: var(--color-text);
      font-weight: 500;
    }

    :deep(.el-switch) {
      --el-switch-on-color: #576BFF;
    }
  }

  .demand-module {
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    gap: 5px;
    border: 1px solid var(--color-td-border);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
    padding: 5px;
    overflow: hidden;
    margin: 5px 0;

    // 左侧：分组信息
    .demand-group-info {
      flex: 0 0 210px;
      background: rgba(43, 87, 238, 0.04);
      border-radius: 6px;
      padding: 5px;
      // border: 1px solid #e8e8e8;
      overflow-y: auto;
      max-height: 300px;

      .group-devices {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .device-item {
          background: transparent;
          padding: 5px 5px;
          border-radius: 4px;

          .device-item-info {
            display: flex;
            flex-direction: column;
            gap: 3px;

            .device-item-info-item {
              display: flex;
              // justify-content: space-between;
              align-items: center;
              font-size: 12px;

              .device-item-info-item-label {
                color: rgba(0, 0, 0, 0.5);
                margin-right: 5px;
                text-align: right;
              }

              .device-item-info-item-value {
                color: var(--color-text);
                font-weight: 500;
                text-align: left;
              }
            }
          }
        }
      }
    }

    // 右侧：配置信息
    .demand-config {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 15px;
      overflow: hidden;

      .config-item {
        background: rgba(43, 87, 238, 0.04);
        border-radius: 6px;
        padding: 10px;

        .config-input-row {
          display: flex;
          align-items: center;
          gap: 5px;
          margin-bottom: 10px;



          .config-input {
            flex: 1;
            display: flex;
            align-items: center;
            gap: 5px;

            .el-input-number {
              width: 120px;
            }


          }
        }

        .config-label {
          min-width: 100px;
          font-weight: 500;
          display: flex;
          align-items: center;
          flex-flow: row;
        }

        .input-tip {
          display: flex;
          align-items: center;
          gap: 4px;
          margin-left: 8px;

          .tip-icon {
            color: #409EFF;
            font-size: 14px;
          }

          .tip-text {
            color: #979797;
            font-size: 12px;
            white-space: nowrap;
          }
        }

        // 12 个月等宽平铺：改用 grid 而非固定 80px 的 flex 项，
        // 既不会撑出横向滚动条，也保证标签行与输入框行逐列对齐
        .monthly-values {
          .month-labels-row,
          .month-inputs-row {
            display: grid;
            grid-template-columns: repeat(12, minmax(0, 1fr));
            gap: 4px;
          }

          .month-labels-row {
            margin-bottom: 5px;

            .month-label {
              text-align: center;
              font-size: 12px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .month-inputs-row {
            .el-input-number {
              width: 100%;
              // el-input-number 自带 min-width，不清掉会顶开 grid 轨道
              min-width: 0;
            }

            // 窄列下压缩内边距并居中，保证数字能完整显示
            :deep(.el-input__wrapper) {
              padding-left: 4px;
              padding-right: 4px;
            }

            :deep(.el-input__inner) {
              text-align: center;
              padding: 0;
              font-size: 12px;
            }
          }
        }
      }
    }

    // 保存按钮
    .demand-actions {
      margin-top: 10px;
      display: flex;
      justify-content: flex-end;

      :deep(.el-button) {
        color: #ffffff;
      }
    }
  }
}

// 美化滚动条样式
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(144, 147, 153, 0.4);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(144, 147, 153, 0.6);
}

// 差异高亮样式
.diff-month {
  color: #ff4d4f !important;
  border-color: #ff4d4f !important;

  &.month-label {
    color: #ff4d4f !important;
    font-weight: bold;
  }

  &.el-input-number {
    :deep(.el-input__wrapper) {
      border-color: #ff4d4f !important;
      box-shadow: 0 0 0 1px #ff4d4f !important;
    }
  }
}

/* ===================================================================
 * 浅色主题适配：原组件为深色主题（#1F2536/#2E3648/#687DFF），
 * 此处按系统浅色玻璃拟态风格覆盖。原深色规则嵌套较深，故此处用 !important
 * 保证覆盖（同时匹配到弹框/时间线等 teleport 场景）。
 * =================================================================== */
.advanced-config-container {
  --ac-panel-bg: rgba(255, 255, 255, 0.6);
  --ac-card-bg: #ffffff;
  --ac-inner-bg: rgba(43, 87, 238, 0.04);
  --ac-border: rgba(0, 0, 0, 0.08);
  --ac-text: #2e2e2e;
  --ac-text-secondary: rgba(0, 0, 0, 0.5);
  --ac-primary: var(--color-primary);

  .left-panel .section-card,
  .right-panel {
    background: var(--ac-panel-bg) !important;
    border: 0.5px solid rgba(255, 255, 255, 0.8) !important;
    box-shadow: 0 2px 12px rgba(8, 40, 87, 0.05);
  }

  .section-title {
    color: var(--ac-text) !important;
    border-left-color: var(--ac-primary) !important;
  }

  .group-block {
    background: var(--ac-card-bg) !important;
    border: 1px solid var(--ac-border) !important;
    box-shadow: 0 2px 8px rgba(8, 40, 87, 0.06);

    &:hover:not(.active) {
      background: #ffffff !important;
      border-color: var(--ac-primary) !important;
      box-shadow: 0 4px 14px rgba(43, 87, 238, 0.18) !important;
    }

    &.active {
      border-color: var(--ac-primary) !important;
      box-shadow: 0 4px 14px rgba(43, 87, 238, 0.22);
    }

    .card-header .card-index {
      background: var(--ac-primary) !important;
      color: #fff !important;
    }

    .card-header .group-name,
    .card-body .detail-item .item-value {
      color: var(--ac-text) !important;
    }

    .card-body .section-subtitle {
      color: var(--ac-text-secondary) !important;
      border-bottom-color: var(--ac-border) !important;
    }

    .card-body .elink-details,
    .card-body .group-settings-section {
      background: var(--ac-inner-bg) !important;
      box-shadow: none !important;
    }

    .card-body .detail-item .item-label,
    .card-body .setting-item .setting-label {
      color: var(--ac-text-secondary) !important;
    }
  }

  // eLink 内层卡片（el-card）在浅色下透明即可
  .elink-list-section-card,
  :deep(.elink-list-section-card .el-card__body) {
    background: transparent !important;
    color: var(--ac-text) !important;
  }

  .communication-mode-container .mode-selection {
    background: var(--ac-inner-bg) !important;
    display: flex;
    flex-direction: row;
    gap: 20px;
    .mode-options{
      display: flex;
      flex-flow: column;
    }
    .mode-radio-group{
       display: flex;
      flex-flow: column;
      align-items:start !important;
    }

    .mode-options .el-radio {
      color: var(--ac-text) !important;
    }

    .mode-description {
      background: var(--ac-card-bg) !important;
      border: 1px solid var(--ac-border);

      .subtitle,
      .desc-text .sub-item .sub-item-title {
        color: var(--ac-text) !important;
      }

      .desc-text {
        color: var(--ac-text-secondary) !important;
      }
    }
  }

  // 授权弹框内容（若在容器内渲染时）
  .auth-dialog-content {
    background-color: var(--ac-card-bg) !important;

    .phone-verify .phone-input .label,
    .auth-text .auth-item {
      color: var(--ac-text-secondary) !important;
    }

    .phone-verify .phone-input .value {
      color: var(--ac-text) !important;
    }
  }

  // 时间线（操作历史）主色
  :deep(.el-timeline-item__node) {
    --el-timeline-node-color: var(--ac-primary);
  }

  /* ---------- 操作历史：去掉横向滚动条，内容一律换行 ---------- */
  .right-panel {
    overflow-x: hidden !important;

    .ac-history-timeline {
      width: 100%;
      max-width: 100% !important;
      padding-left: 0;
    }

    :deep(.el-timeline-item__wrapper) {
      padding-left: 20px;
      overflow: hidden;
    }

    :deep(.el-timeline-item__timestamp) {
      word-break: break-all;
    }

    .card-container {
      width: 100%;
      overflow: hidden;

      .item-container {
        display: flex;
        align-items: flex-start;
        margin-bottom: 6px;

        .title {
          flex-shrink: 0;
          color: var(--ac-text-secondary);
        }

        .content {
          flex: 1;
          min-width: 0;
          color: var(--ac-text);
          word-break: break-all;
          overflow-wrap: anywhere;
        }
      }
    }

    // 详情展开/收起按钮
    .history-detail-toggle {
      padding: 0;
      height: auto;
      margin-bottom: 4px;
    }

    // 需量操作详情：展开后完整展示；内容较宽时保留横向滚动条兜底，不裁剪
    .demand-operation-content {
      width: 100%;
      max-width: 100%;
      overflow-x: auto;
    }
  }

  /* ---------- 分组信息：eLink 卡片宽高一致 ---------- */
  .group-block .card-body .elink-details {
    .elink-list-section {
      flex-flow: row wrap;
      gap: 10px;

      .elink-list-section-card {
        flex: 0 0 auto;
        width: 240px;
        min-height: 116px;
        margin-bottom: 0 !important;
        background: var(--ac-card-bg) !important;
        border: 1px solid var(--ac-border) !important;
        border-radius: 8px;
        box-sizing: border-box;

        :deep(.el-card__body) {
          padding: 12px 14px !important;
          height: 100%;
          box-sizing: border-box;
        }

        .detail-item .item-value {
          word-break: break-all;
          overflow-wrap: anywhere;
        }
      }
    }
  }

  /* ---------- 分组卡片等高，整体布局更整齐 ---------- */
  .group-block-container {
    align-items: stretch;

    .group-block {
      min-width: 300px;
    }
  }
}
</style>